import React from "react";

import { withT } from "services/translation/";

import { OverlayTrigger, Tooltip } from "react-bootstrap";

import Icon from "components/Icons/Icon";

function AbnormalEvent({ t }) {
  return (
    <OverlayTrigger
      placement="right"
      overlay={
        <Tooltip id={`tooltip-right`} style={{ pointerEvents: "none" }}>
          <div style={{ fontSize: "12px" }} className="py-1">
            <b>{t("title")}</b>
            <br />
            {t("description")}
          </div>
        </Tooltip>
      }>
      <Icon className="fas fa-exclamation-circle" />
    </OverlayTrigger>
  );
}

export default withT(
  AbnormalEvent,
  "reports.scheduled.data_table.abnormal_event_tooltip"
);
